<template>
  <div v-if="prepareSupplementList.length > 0">
    <p style="margin: 20px 0 5px;"><strong>Supplement charge: </strong></p>
    <table style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%" class="avoid">
      <tr style="background: #f3f3f3" class="avoid">
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Supplement Charge</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Type</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Price</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Unit</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Period of Stay</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Condition</strong></p>
        </th>
      </tr>
      <tr v-for="(supplement) of prepareSupplementList" :key="`supplement-${supplement.id}`" class="avoid">
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{supplement.name}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{getSupplementTypeName(supplement.supplementTypeId)}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{numberFormat(supplement.price)}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{bindSupplementUnitType(supplement.priceType, supplement.unitType)}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p><span v-html="bindSupplementPeriod(supplement.periodOfStayList)"></span></p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{supplement.conditionDetail}}</p>
        </td>
      </tr>
    </table>
    <div v-if="bindSupplementRemark().trim() !== ''" class="editor-preview avoid">
      <p style="margin: 5px 0 5px;">
        <strong>Remark: </strong>
      </p>
      <div v-html="bindSupplementRemark()"></div>
    </div>
  </div>
</template>
<script>
import { SUPPLEMENT_PRICE_TYPE, SUPPLEMENT_UNIT_TYPE, REMARK_TYPE } from '@/configs/constant'
import { numberFormat } from '@/helpers'
import { isValidStartEndInPeriod, getPeriodStartDate, getPeriodEndDate, dateFormat } from '@/helpers/datetime'
import { get, compact } from 'lodash'
import { applyRemarkTableStyle } from '@/domains/contract-domain'

export default {
  name: 'Supplement',
  props: {
    contractStartDate: {
      type: String,
      default: ''
    },
    contractEndDate: {
      type: String,
      default: ''
    },
    supplementList: {
      type: Array,
      default: () => {
        return []
      }
    },
    supplementTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      numberFormat
    }
  },
  computed: {
    prepareSupplementList: function () {
      const contractStartDate = this.contractStartDate
      const contractEndDate = this.contractEndDate

      const supplementList = this.supplementList.map((supplement) => {
        const periodOfStayList = get(supplement, 'periodOfStayList', [])

        if (periodOfStayList.length === 0) {
          return supplement
        }

        const newPeriodOfStayList = periodOfStayList.map((item) => {
          if (isValidStartEndInPeriod(contractStartDate, contractEndDate, item.startDate, item.endDate)) {
            const startDate = getPeriodStartDate(contractStartDate, item.startDate)
            const endDate = getPeriodEndDate(contractEndDate, item.endDate)

            const newPeriod = {
              startDate: startDate,
              endDate: endDate
            }
            const newItem = Object.assign({}, item, newPeriod)

            return newItem
          }
        })
        const filteredPeriodOfStayList = compact(newPeriodOfStayList)

        if (filteredPeriodOfStayList.length > 0) {
          const newPeriodOfStayList = {
            periodOfStayList: filteredPeriodOfStayList
          }
          const newSupplement = Object.assign({}, supplement, newPeriodOfStayList)

          return newSupplement
        }
      })
      const newSupplementList = compact(supplementList)

      return newSupplementList
    }
  },
  methods: {
    bindSupplementUnitType: function (priceType, unitType) {
      let typeStr = (priceType === SUPPLEMENT_PRICE_TYPE.NET) ? 'Net ' : 'Percent '

      switch (unitType) {
        case SUPPLEMENT_UNIT_TYPE.PER_PERSON:
          typeStr += 'per person'
          break
        case SUPPLEMENT_UNIT_TYPE.PER_ROOM:
          typeStr += 'per room'
          break
        case SUPPLEMENT_UNIT_TYPE.PER_BOOKING:
          typeStr += 'per booking'
          break
        case SUPPLEMENT_UNIT_TYPE.DISCOUNT:
          typeStr += 'discount'
          break
      }

      return typeStr
    },
    bindSupplementPeriod: function (periodList) {
      if (periodList === undefined || periodList.length === 0) {
        return 'All'
      }

      let periodStayStrList = []

      for (let period of periodList) {
        const periodStr = this._getDateFromTo(period.startDate, period.endDate)
        periodStayStrList.push(periodStr)
      }

      return periodStayStrList.join(', <br />')
    },
    _getDateFromTo: function (startDateStr, endDateStr) {
      let dateFromToStr = '-'

      if (startDateStr !== undefined && endDateStr !== undefined) {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)

        dateFromToStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return dateFromToStr
    },
    getSupplementTypeName: function (supplementTypeId) {
      const supplementType = this.supplementTypeList.find(item => item.id === supplementTypeId)
      return (!supplementType) ? 'N/A' : supplementType.name
    },
    bindSupplementRemark: function () {
      const remark = applyRemarkTableStyle(this.remarkList, REMARK_TYPE.SUPPLEMENT)

      return remark
    }
  }
}
</script>
<style scoped>
  p {
    display: block;
    margin-block-start: 0px;
    margin-block-end:0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .remark > p {
    margin: 5px 0 10px;
  }
</style>
